import type { ProjectsV3ListProjectConnectbaseTasksResponse } from '@civilgrid/rest-client';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

export type ProjectConnectbaseTasksResponse = ProjectsV3ListProjectConnectbaseTasksResponse;
export type ConnectbaseTaskKey = ProjectConnectbaseTasksResponse['tasks'][number]['task'];
export type ConnectbaseNoticeStatus = ProjectConnectbaseTasksResponse['tasks'][number]['status'];

export function projectConnectbaseTasksQueryKey(projectId: string) {
  return ['project-connectbase-tasks', { projectId }] as const;
}

export async function fetchProjectConnectbaseTasks(projectId: string): Promise<ProjectConnectbaseTasksResponse> {
  const { data } = await axios({
    method: 'GET',
    url: `/v3/projects/${projectId}/connectbase-tasks`,
    // The Utilities tab holds back its error message until this settles, so a stalled request must not hang it.
    timeout: 30_000,
  });
  return data;
}
